var _circle, _path, _circle2, _circle3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.4999,
    cy: 38,
    r: 36.5,
    fill: "#923094",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9693 67.2498C69.5243 60.3768 75.0002 49.8279 75.0002 38C75.0002 17.2893 58.2109 0.5 37.5002 0.5C28.094 0.5 19.4967 3.96316 12.9137 9.68397L60.9693 67.2498Z",
    fill: "#A859A9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.4999,
    cy: 38,
    r: 36,
    stroke: "white",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.4999,
    cy: 38,
    r: 20,
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.043 37.1149L35.4592 43.896C35.4592 43.896 41.0094 30.1047 49.7606 25.5C49.5453 28.776 48.6913 31.6396 50.1864 35.1447C46.3443 36.0153 38.4472 45.8891 35.8851 50.7C33.0558 46.7934 29.3202 43.6329 24.9999 41.4905L32.043 37.1149Z",
    fill: "#923094"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzUiIGhlaWdodD0iNzYiIHZpZXdCb3g9IjAgMCA3NSA3NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzcuNDk5OSIgY3k9IjM4IiByPSIzNi41IiBmaWxsPSIjOTIzMDk0IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02MC45NjkzIDY3LjI0OThDNjkuNTI0MyA2MC4zNzY4IDc1LjAwMDIgNDkuODI3OSA3NS4wMDAyIDM4Qzc1LjAwMDIgMTcuMjg5MyA1OC4yMTA5IDAuNSAzNy41MDAyIDAuNUMyOC4wOTQgMC41IDE5LjQ5NjcgMy45NjMxNiAxMi45MTM3IDkuNjgzOTdMNjAuOTY5MyA2Ny4yNDk4WiIgZmlsbD0iI0E4NTlBOSIvPgo8Y2lyY2xlIGN4PSIzNy40OTk5IiBjeT0iMzgiIHI9IjM2IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiLz4KPGNpcmNsZSBjeD0iMzcuNDk5OSIgY3k9IjM4IiByPSIyMCIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMyIvPgo8cGF0aCBkPSJNMzIuMDQzIDM3LjExNDlMMzUuNDU5MiA0My44OTZDMzUuNDU5MiA0My44OTYgNDEuMDA5NCAzMC4xMDQ3IDQ5Ljc2MDYgMjUuNUM0OS41NDUzIDI4Ljc3NiA0OC42OTEzIDMxLjYzOTYgNTAuMTg2NCAzNS4xNDQ3QzQ2LjM0NDMgMzYuMDE1MyAzOC40NDcyIDQ1Ljg4OTEgMzUuODg1MSA1MC43QzMzLjA1NTggNDYuNzkzNCAyOS4zMjAyIDQzLjYzMjkgMjQuOTk5OSA0MS40OTA1TDMyLjA0MyAzNy4xMTQ5WiIgZmlsbD0iIzkyMzA5NCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };